module.exports = __webpack_public_path__ + "media/1alB-s-setw.11fd0f4b.mp3";